export default __webpack_public_path__ + "de294f18393c129c45bc313a64e82af0.png";